/**
 * Configurator API
 * Configurator API documentation
 *
 * OpenAPI spec version: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpResponse, HttpEvent } from '@angular/common/http';
import { CustomHttpUrlEncodingCodec } from '../encoder';

import { Observable } from 'rxjs';

import { ConditionIfStepDTO } from '../model/conditionIfStepDTO';
import { EmailStepDTO } from '../model/emailStepDTO';
import { SaveQueryStepDTO } from '../model/saveQueryStepDTO';
import { SmsStepDTO } from '../model/smsStepDTO';

import { CreateScenarioDTO } from '../model/createScenarioDTO';
import { DuplicateScenarioRequestDTO } from '../model/duplicateScenarioRequestDTO';
import { ScenarioDTO } from '../model/scenarioDTO';
import { ScenarioExecutionLog } from '../model/scenarioExecutionLog';
import { ScenarioVersion } from '../model/scenarioVersion';
import { ScenarioVersionLiteDTO } from '../model/scenarioVersionLiteDTO';
import { UpdateScenarioDTO } from '../model/updateScenarioDTO';
import { UpdateScenarioVersionDTO } from '../model/updateScenarioVersionDTO';

import { BASE_PATH } from '../variables';
import { Configuration } from '../configuration';

@Injectable()
export class ConfiguratorScenarioService {

    protected basePath = 'https://dmp.airiane.com/services/configurator';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * 
     * @param body 
     * @param xDataStoreID 
     * @param X_PARTNER_ID 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public create(body: CreateScenarioDTO, xDataStoreID: string, observe?: 'body', reportProgress?: boolean): Observable<ScenarioVersion>;
    public create(body: CreateScenarioDTO, xDataStoreID: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ScenarioVersion>>;
    public create(body: CreateScenarioDTO, xDataStoreID: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ScenarioVersion>>;
    public create(body: CreateScenarioDTO, xDataStoreID: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling create.');
        }

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling create.');
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<ScenarioVersion>('post', `${this.basePath}/api/scenarios`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param xDataStoreID 
     * @param X_PARTNER_ID 
     * @param scenarioId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public deleteScenario(xDataStoreID: string, X_PARTNER_ID: string, scenarioId: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public deleteScenario(xDataStoreID: string, X_PARTNER_ID: string, scenarioId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public deleteScenario(xDataStoreID: string, X_PARTNER_ID: string, scenarioId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public deleteScenario(xDataStoreID: string, X_PARTNER_ID: string, scenarioId: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling deleteScenario.');
        }

        if (X_PARTNER_ID === null || X_PARTNER_ID === undefined) {
            throw new Error('Required parameter X_PARTNER_ID was null or undefined when calling deleteScenario.');
        }

        if (scenarioId === null || scenarioId === undefined) {
            throw new Error('Required parameter scenarioId was null or undefined when calling deleteScenario.');
        }

        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (X_PARTNER_ID !== undefined && X_PARTNER_ID !== null) {
            queryParameters = queryParameters.set('X-PARTNER-ID', <any>X_PARTNER_ID);
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<any>('delete', `${this.basePath}/api/scenarios/${encodeURIComponent(String(scenarioId))}`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param xDataStoreID 
     * @param X_PARTNER_ID 
     * @param scenarioId 
     * @param version 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public duplicate(xDataStoreID: string, X_PARTNER_ID: string, scenarioId: string, version: number, body?: DuplicateScenarioRequestDTO, observe?: 'body', reportProgress?: boolean): Observable<ScenarioDTO>;
    public duplicate(xDataStoreID: string, X_PARTNER_ID: string, scenarioId: string, version: number, body?: DuplicateScenarioRequestDTO, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ScenarioDTO>>;
    public duplicate(xDataStoreID: string, X_PARTNER_ID: string, scenarioId: string, version: number, body?: DuplicateScenarioRequestDTO, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ScenarioDTO>>;
    public duplicate(xDataStoreID: string, X_PARTNER_ID: string, scenarioId: string, version: number, body?: DuplicateScenarioRequestDTO, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling duplicate.');
        }

        if (X_PARTNER_ID === null || X_PARTNER_ID === undefined) {
            throw new Error('Required parameter X_PARTNER_ID was null or undefined when calling duplicate.');
        }

        if (scenarioId === null || scenarioId === undefined) {
            throw new Error('Required parameter scenarioId was null or undefined when calling duplicate.');
        }

        if (version === null || version === undefined) {
            throw new Error('Required parameter version was null or undefined when calling duplicate.');
        }


        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (X_PARTNER_ID !== undefined && X_PARTNER_ID !== null) {
            queryParameters = queryParameters.set('X-PARTNER-ID', <any>X_PARTNER_ID);
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<ScenarioDTO>('post', `${this.basePath}/api/scenarios/${encodeURIComponent(String(scenarioId))}/versions/${encodeURIComponent(String(version))}:duplicate`,
            {
                body: body,
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param xDataStoreID 
     * @param scenarioId 
     * @param version 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getVersion(xDataStoreID: string, scenarioId: string, version: number, observe?: 'body', reportProgress?: boolean): Observable<ScenarioDTO>;
    public getVersion(xDataStoreID: string, scenarioId: string, version: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ScenarioDTO>>;
    public getVersion(xDataStoreID: string, scenarioId: string, version: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ScenarioDTO>>;
    public getVersion(xDataStoreID: string, scenarioId: string, version: number, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling getVersion.');
        }

        if (scenarioId === null || scenarioId === undefined) {
            throw new Error('Required parameter scenarioId was null or undefined when calling getVersion.');
        }

        if (version === null || version === undefined) {
            throw new Error('Required parameter version was null or undefined when calling getVersion.');
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<ScenarioDTO>('get', `${this.basePath}/api/scenarios/${encodeURIComponent(String(scenarioId))}/versions/${encodeURIComponent(String(version))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param xDataStoreID 
     * @param X_PARTNER_ID 
     * @param status 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public listOrLatest(xDataStoreID: string, X_PARTNER_ID: string, status?: string, create?: boolean, observe?: 'body', reportProgress?: boolean): Observable<Array<ScenarioDTO>>;
    public listOrLatest(xDataStoreID: string, X_PARTNER_ID: string, status?: string, create?: boolean, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<ScenarioDTO>>>;
    public listOrLatest(xDataStoreID: string, X_PARTNER_ID: string, status?: string, create?: boolean, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<ScenarioDTO>>>;
    public listOrLatest(xDataStoreID: string, X_PARTNER_ID: string, status?: string, create?: boolean, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling listOrLatest.');
        }

        if (X_PARTNER_ID === null || X_PARTNER_ID === undefined) {
            throw new Error('Required parameter X_PARTNER_ID was null or undefined when calling listOrLatest.');
        }


        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (X_PARTNER_ID !== undefined && X_PARTNER_ID !== null) {
            queryParameters = queryParameters.set('X-PARTNER-ID', <any>X_PARTNER_ID);
        }
        if (status !== undefined && status !== null) {
            queryParameters = queryParameters.set('status', <any>status);
        }
        if (create !== undefined && create !== null) {
            queryParameters = queryParameters.set('create', <any>create);
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<ScenarioDTO>>('get', `${this.basePath}/api/scenarios`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param xDataStoreID 
     * @param scenarioId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public listVersions(xDataStoreID: string, scenarioId: string, observe?: 'body', reportProgress?: boolean): Observable<Array<ScenarioVersionLiteDTO>>;
    public listVersions(xDataStoreID: string, scenarioId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<ScenarioVersionLiteDTO>>>;
    public listVersions(xDataStoreID: string, scenarioId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<ScenarioVersionLiteDTO>>>;
    public listVersions(xDataStoreID: string, scenarioId: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling listVersions.');
        }

        if (scenarioId === null || scenarioId === undefined) {
            throw new Error('Required parameter scenarioId was null or undefined when calling listVersions.');
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<ScenarioVersionLiteDTO>>('get', `${this.basePath}/api/scenarios/${encodeURIComponent(String(scenarioId))}/versions`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param xDataStoreID 
     * @param X_PARTNER_ID 
     * @param scenarioId 
     * @param version 
     * @param from 
     * @param to 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public logs(xDataStoreID: string, X_PARTNER_ID: string, scenarioId: string, version: number, from?: Date, to?: Date, observe?: 'body', reportProgress?: boolean): Observable<Array<ScenarioExecutionLog>>;
    public logs(xDataStoreID: string, X_PARTNER_ID: string, scenarioId: string, version: number, from?: Date, to?: Date, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<ScenarioExecutionLog>>>;
    public logs(xDataStoreID: string, X_PARTNER_ID: string, scenarioId: string, version: number, from?: Date, to?: Date, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<ScenarioExecutionLog>>>;
    public logs(xDataStoreID: string, X_PARTNER_ID: string, scenarioId: string, version: number, from?: Date, to?: Date, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling logs.');
        }

        if (X_PARTNER_ID === null || X_PARTNER_ID === undefined) {
            throw new Error('Required parameter X_PARTNER_ID was null or undefined when calling logs.');
        }

        if (scenarioId === null || scenarioId === undefined) {
            throw new Error('Required parameter scenarioId was null or undefined when calling logs.');
        }

        if (version === null || version === undefined) {
            throw new Error('Required parameter version was null or undefined when calling logs.');
        }



        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (X_PARTNER_ID !== undefined && X_PARTNER_ID !== null) {
            queryParameters = queryParameters.set('X-PARTNER-ID', <any>X_PARTNER_ID);
        }
        if (from !== undefined && from !== null) {
            queryParameters = queryParameters.set('from', <any>from.toISOString());
        }
        if (to !== undefined && to !== null) {
            queryParameters = queryParameters.set('to', <any>to.toISOString());
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<ScenarioExecutionLog>>('post', `${this.basePath}/api/scenarios/${encodeURIComponent(String(scenarioId))}/versions/${encodeURIComponent(String(version))}/logs`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param xDataStoreID 
     * @param scenarioId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public newVersion(xDataStoreID: string, scenarioId: string, observe?: 'body', reportProgress?: boolean): Observable<ScenarioVersion>;
    public newVersion(xDataStoreID: string, scenarioId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ScenarioVersion>>;
    public newVersion(xDataStoreID: string, scenarioId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ScenarioVersion>>;
    public newVersion(xDataStoreID: string, scenarioId: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling newVersion.');
        }

        if (scenarioId === null || scenarioId === undefined) {
            throw new Error('Required parameter scenarioId was null or undefined when calling newVersion.');
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<ScenarioVersion>('post', `${this.basePath}/api/scenarios/${encodeURIComponent(String(scenarioId))}/versions`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param xDataStoreID 
     * @param scenarioId 
     * @param version 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updateInfo(body: UpdateScenarioDTO, xDataStoreID: string, scenarioId: string, version: number, observe?: 'body', reportProgress?: boolean): Observable<ScenarioDTO>;
    public updateInfo(body: UpdateScenarioDTO, xDataStoreID: string, scenarioId: string, version: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ScenarioDTO>>;
    public updateInfo(body: UpdateScenarioDTO, xDataStoreID: string, scenarioId: string, version: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ScenarioDTO>>;
    public updateInfo(body: UpdateScenarioDTO, xDataStoreID: string, scenarioId: string, version: number, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling updateInfo.');
        }

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling updateInfo.');
        }

        if (scenarioId === null || scenarioId === undefined) {
            throw new Error('Required parameter scenarioId was null or undefined when calling updateInfo.');
        }

        if (version === null || version === undefined) {
            throw new Error('Required parameter version was null or undefined when calling updateInfo.');
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<ScenarioDTO>('put', `${this.basePath}/api/scenarios/${encodeURIComponent(String(scenarioId))}/versions/${encodeURIComponent(String(version))}:info`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param xDataStoreID 
     * @param X_PARTNER_ID 
     * @param scenarioId 
     * @param version 
     * @param status 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updateStatus(xDataStoreID: string, X_PARTNER_ID: string, scenarioId: string, version: number, status: string, observe?: 'body', reportProgress?: boolean): Observable<ScenarioVersion>;
    public updateStatus(xDataStoreID: string, X_PARTNER_ID: string, scenarioId: string, version: number, status: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ScenarioVersion>>;
    public updateStatus(xDataStoreID: string, X_PARTNER_ID: string, scenarioId: string, version: number, status: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ScenarioVersion>>;
    public updateStatus(xDataStoreID: string, X_PARTNER_ID: string, scenarioId: string, version: number, status: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling updateStatus.');
        }

        if (X_PARTNER_ID === null || X_PARTNER_ID === undefined) {
            throw new Error('Required parameter X_PARTNER_ID was null or undefined when calling updateStatus.');
        }

        if (scenarioId === null || scenarioId === undefined) {
            throw new Error('Required parameter scenarioId was null or undefined when calling updateStatus.');
        }

        if (version === null || version === undefined) {
            throw new Error('Required parameter version was null or undefined when calling updateStatus.');
        }

        if (status === null || status === undefined) {
            throw new Error('Required parameter status was null or undefined when calling updateStatus.');
        }

        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (X_PARTNER_ID !== undefined && X_PARTNER_ID !== null) {
            queryParameters = queryParameters.set('X-PARTNER-ID', <any>X_PARTNER_ID);
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<ScenarioVersion>('post', `${this.basePath}/api/scenarios/${encodeURIComponent(String(scenarioId))}/version/${encodeURIComponent(String(version))}:statusScenario:${encodeURIComponent(String(status))}`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param xDataStoreID 
     * @param scenarioId 
     * @param version 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updateSteps(body: Array<ConditionIfStepDTO | EmailStepDTO | SaveQueryStepDTO | SmsStepDTO>, xDataStoreID: string, scenarioId: string, version: number, observe?: 'body', reportProgress?: boolean): Observable<ScenarioDTO>;
    public updateSteps(body: Array<ConditionIfStepDTO | EmailStepDTO | SaveQueryStepDTO | SmsStepDTO>, xDataStoreID: string, scenarioId: string, version: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ScenarioDTO>>;
    public updateSteps(body: Array<ConditionIfStepDTO | EmailStepDTO | SaveQueryStepDTO | SmsStepDTO>, xDataStoreID: string, scenarioId: string, version: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ScenarioDTO>>;
    public updateSteps(body: Array<ConditionIfStepDTO | EmailStepDTO | SaveQueryStepDTO | SmsStepDTO>, xDataStoreID: string, scenarioId: string, version: number, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling updateSteps.');
        }

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling updateSteps.');
        }

        if (scenarioId === null || scenarioId === undefined) {
            throw new Error('Required parameter scenarioId was null or undefined when calling updateSteps.');
        }

        if (version === null || version === undefined) {
            throw new Error('Required parameter version was null or undefined when calling updateSteps.');
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<ScenarioDTO>('put', `${this.basePath}/api/scenarios/${encodeURIComponent(String(scenarioId))}/versions/${encodeURIComponent(String(version))}:workflow`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param xDataStoreID 
     * @param scenarioId 
     * @param version 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updateVersion(body: UpdateScenarioVersionDTO, xDataStoreID: string, scenarioId: string, version: number, observe?: 'body', reportProgress?: boolean): Observable<ScenarioDTO>;
    public updateVersion(body: UpdateScenarioVersionDTO, xDataStoreID: string, scenarioId: string, version: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ScenarioDTO>>;
    public updateVersion(body: UpdateScenarioVersionDTO, xDataStoreID: string, scenarioId: string, version: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ScenarioDTO>>;
    public updateVersion(body: UpdateScenarioVersionDTO, xDataStoreID: string, scenarioId: string, version: number, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling updateVersion.');
        }

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling updateVersion.');
        }

        if (scenarioId === null || scenarioId === undefined) {
            throw new Error('Required parameter scenarioId was null or undefined when calling updateVersion.');
        }

        if (version === null || version === undefined) {
            throw new Error('Required parameter version was null or undefined when calling updateVersion.');
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<ScenarioDTO>('put', `${this.basePath}/api/scenarios/${encodeURIComponent(String(scenarioId))}/versions/${encodeURIComponent(String(version))}:version`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Exporter un scénario au format JSON
     * Cette requête permet d'exporter un scénario au format JSON. (code 200)
     * @param xDataStoreID
     * @param scenarioId
     * @param version
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public exportScenarioJson(xDataStoreID: string, scenarioId: string, version: number, observe?: 'body', reportProgress?: boolean): Observable<Blob>;
    public exportScenarioJson(xDataStoreID: string, scenarioId: string, version: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Blob>>;
    public exportScenarioJson(xDataStoreID: string, scenarioId: string, version: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Blob>>;
    public exportScenarioJson(xDataStoreID: string, scenarioId: string, version: number, observe: any = 'body', reportProgress = false ): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling exportScenarioJson.');
        }

        if (scenarioId === null || scenarioId === undefined) {
            throw new Error('Required parameter scenarioId was null or undefined when calling exportScenarioJson.');
        }

        if (version === null || version === undefined) {
            throw new Error('Required parameter version was null or undefined when calling exportScenarioJson.');
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        return this.httpClient.request('get',`${this.basePath}/api/scenarios/export/${encodeURIComponent(String(scenarioId))}/versions/${encodeURIComponent(String(version))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress,
                responseType: 'blob'
            }
        );
    }

    /**
     * Exporter plusieurs scénarios au format ZIP
     * Cette requête permet d'exporter plusieurs scénarios dans une archive ZIP. (code 200)
     * @param xDataStoreID
     * @param scenarioIds
     * @param versions
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public exportScenariosZip(xDataStoreID: string, scenarioIds: string[], versions: number[], observe?: 'body', reportProgress?: boolean): Observable<Blob>;
    public exportScenariosZip(xDataStoreID: string, scenarioIds: string[], versions: number[], observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Blob>>;
    public exportScenariosZip(xDataStoreID: string, scenarioIds: string[], versions: number[], observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Blob>>;
    public exportScenariosZip(xDataStoreID: string, scenarioIds: string[], versions: number[], observe: any = 'body', reportProgress = false ): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling exportScenariosZip.');
        }

        if (scenarioIds === null || scenarioIds === undefined) {
            throw new Error('Required parameter scenarioIds was null or undefined when calling exportScenariosZip.');
        }

        if (versions === null || versions === undefined) {
            throw new Error('Required parameter versions was null or undefined when calling exportScenariosZip.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (scenarioIds) {
            scenarioIds.forEach((element) => {
                queryParameters = queryParameters.append('scenarioIds', <any>element);
            })
        }
        if (versions) {
            versions.forEach((element) => {
                queryParameters = queryParameters.append('versions', <any>element);
            })
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        return this.httpClient.request('get',`${this.basePath}/api/scenarios/export/zip`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress,
                responseType: 'blob'
            }
        );
    }

    /**
     * Importer un scénario depuis JSON
     * Cette requête permet d'importer un scénario depuis un JSON. (code 201)
     * @param xDataStoreID
     * @param body
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importScenarioJson(xDataStoreID: string, body: string, observe?: 'body', reportProgress?: boolean): Observable<ScenarioDTO>;
    public importScenarioJson(xDataStoreID: string, body: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ScenarioDTO>>;
    public importScenarioJson(xDataStoreID: string, body: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ScenarioDTO>>;
    public importScenarioJson(xDataStoreID: string, body: string, observe: any = 'body', reportProgress = false ): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling importScenarioJson.');
        }

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling importScenarioJson.');
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        headers = headers.set('Content-Type', 'application/json');

        return this.httpClient.request<ScenarioDTO>('post',`${this.basePath}/api/scenarios/import/json`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Importer plusieurs scénarios depuis ZIP
     * Cette requête permet d'importer plusieurs scénarios depuis une archive ZIP. (code 200)
     * @param xDataStoreID
     * @param file
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importScenariosZip(xDataStoreID: string, file: Blob, observe?: 'body', reportProgress?: boolean): Observable<Array<ScenarioDTO>>;
    public importScenariosZip(xDataStoreID: string, file: Blob, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<ScenarioDTO>>>;
    public importScenariosZip(xDataStoreID: string, file: Blob, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<ScenarioDTO>>>;
    public importScenariosZip(xDataStoreID: string, file: Blob, observe: any = 'body', reportProgress = false ): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling importScenariosZip.');
        }

        if (file === null || file === undefined) {
            throw new Error('Required parameter file was null or undefined when calling importScenariosZip.');
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        const formData = new FormData();
        formData.append('file', file);

        return this.httpClient.request<Array<ScenarioDTO>>('post',`${this.basePath}/api/scenarios/import/zip`,
            {
                body: formData,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
